export enum AccountCategoryType {
None,
Asset,
Liability,
Equity,
LiabilityEquity,
Revenue,
Expense,
IncomeStatement,
CostOfSales,
MemorandumAccounts,
}
